module.exports = __webpack_public_path__ + "static/media/no_data.cb61ac4f.svg";